import { Container, Form } from 'react-bootstrap';
import { InvestmentFormProps, InvestmentProps } from './investment.types';
import { useEffect, useState } from 'react';

const InvestmentForm = ({
  investmentData,
  handleChange,
  handleFileChange,
}: InvestmentFormProps) => {
  const [formData, setFormData] = useState<InvestmentProps>({
    id: investmentData?.id || undefined,
    amount: investmentData?.amount || 0,
    gat: investmentData?.gat || 0,
    startDate: investmentData?.startDate || '',
    endDate: investmentData?.endDate || '',
    contract: investmentData?.contract || { filename: '', file: '' },
  });

  useEffect(() => {
    if (investmentData) {
      setFormData({
        id: investmentData.id || undefined,
        amount: investmentData.amount || 0,
        gat: investmentData.gat || 0,
        startDate: investmentData.startDate || '',
        endDate: investmentData.endDate || '',
        contract: investmentData.contract || { filename: '', file: '' },
      });
    }
  }, [investmentData]);

  return (
    <Container>
      {/* Monto */}
      <Form.Group className="mb-3">
        <Form.Label>Monto</Form.Label>
        <Form.Control
          type="number"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          onFocus={(e) => e.target.select()}
          required
        />
      </Form.Group>

      {/* GAT */}
      <Form.Group className="mb-3">
        <Form.Label>GAT</Form.Label>
        <Form.Control
          type="number"
          name="gat"
          value={formData.gat}
          onChange={handleChange}
          onFocus={(e) => e.target.select()}
          required
        />
      </Form.Group>

      {/* Fecha de inicio */}
      <Form.Group className="mb-3">
        <Form.Label>Fecha de inicio</Form.Label>
        <Form.Control
          type="date"
          name="startDate"
          value={formData.startDate}
          onChange={handleChange}
          required
        />
      </Form.Group>

      {/* Fecha de fin */}
      <Form.Group className="mb-3">
        <Form.Label>Fecha de fin</Form.Label>
        <Form.Control
          type="date"
          name="endDate"
          value={formData.endDate}
          onChange={handleChange}
          required
        />
      </Form.Group>

      {/* Contrato */}
      <Form.Group className="mb-3">
        <Form.Label>Contrato</Form.Label>
        <Form.Control type="file" onChange={handleFileChange} />
        {formData.contract.filename && (
          <small className="text-muted">Archivo actual: {formData.contract.filename}</small>
        )}
      </Form.Group>
    </Container>
  );
};

export default InvestmentForm;
